import { MyContact } from "../components/Contact";

export default function ContactPage() {
  return (
    <div className="transition">
      <MyContact/>
    </div>
  )
}
